// extracted by mini-css-extract-plugin
export default {"box":"wep9AS","badge":"id0chL","title":"zKXsZz"};